import { CONTAINER_PADDING_ON_SIDES } from './constants';

export const isTileHiddenToTheRight = (container: HTMLElement, tileElement: HTMLElement): boolean => {
    const containerRight = container.getBoundingClientRect().right;
    const tileRight = tileElement.getBoundingClientRect().right;
    return tileRight > containerRight - CONTAINER_PADDING_ON_SIDES;
};
